import * as THREE from "three";
import { GLASS_PARAMS } from "./GlassDefeault";
import { applyRadiusColor } from "./RadiusColor";

export function createGlass5(shearValue, topColor, bottomColor) {
  shearValue = shearValue !== undefined ? shearValue : 0.5;
  const group = new THREE.Group();

  // スケール調整
  const scaleFactor = GLASS_PARAMS.scaleFactor;

  // 誤り5: グラスのすぼまり（テーパー）を描かない誤り（底が太すぎる）
  // 底面半径を上面半径に近づける。shearValue=0 でモチーフと一致、
  // 0.5（誤り）でテーパーを完全に失い寸胴になり、太くなった底が皿のふちに接触して顕在化する
  const bottomRadius =
    GLASS_PARAMS.glass.bottomRadius +
    (GLASS_PARAMS.glass.topRadius - GLASS_PARAMS.glass.bottomRadius) * shearValue * 2;
  const glassGeometry = new THREE.CylinderGeometry(
    GLASS_PARAMS.glass.topRadius * scaleFactor,
    bottomRadius * scaleFactor,
    GLASS_PARAMS.glass.height * scaleFactor,
    GLASS_PARAMS.glass.radialSegments,
    GLASS_PARAMS.glass.heightSegments,
    GLASS_PARAMS.glass.openEnded
  );

  // 側面も同じ上端色で塗る
  applyRadiusColor(glassGeometry, topColor, bottomColor, GLASS_PARAMS.glass.color, topColor);

  const glassMaterial = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    shininess: GLASS_PARAMS.glass.shininess,
    vertexColors: true,
  });
  const glassMesh = new THREE.Mesh(glassGeometry, glassMaterial);
  glassMesh.position.y = (GLASS_PARAMS.glass.height / 2) * scaleFactor;
  group.add(glassMesh);

  // 環境光とスポットライトを追加してリアルに照らす
  const ambientLight = new THREE.AmbientLight(
    GLASS_PARAMS.light.ambient.color,
    GLASS_PARAMS.light.ambient.intensity
  );
  const spotLight = new THREE.SpotLight(
    GLASS_PARAMS.light.spot.color,
    GLASS_PARAMS.light.spot.intensity
  );
  spotLight.position.set(
    ...GLASS_PARAMS.light.spot.position.map(v => v * scaleFactor)
  );
  spotLight.castShadow = true;
  group.add(ambientLight);
  group.add(spotLight);

  return group;
}
